import { createAction, props } from '@ngrx/store';

const purchaserIsCreated = 'PURCHASER_IS_CREATED';
const removeRecentPurchaser = 'REMOVE_RECENT_PURCHASER';
export const purchaserIsCreatedAction = createAction(
  purchaserIsCreated,
  props<{ newPurchaser: any }>()
);

export const removeRecentPurchaserAction = createAction(removeRecentPurchaser);
